/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Tlm_1Inputs */

const en_svc_automation_tlm_1 = /** @type {(inputs: Svc_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trigger_surface`)
};

const ar_svc_automation_tlm_1 = /** @type {(inputs: Svc_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سطح المحفزات`)
};

const bn_svc_automation_tlm_1 = /** @type {(inputs: Svc_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trigger_surface`)
};

const de_svc_automation_tlm_1 = /** @type {(inputs: Svc_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trigger_Oberfläche`)
};

const es_svc_automation_tlm_1 = /** @type {(inputs: Svc_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`superficie_disparador`)
};

const fr_svc_automation_tlm_1 = /** @type {(inputs: Svc_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`surface_de déclenchement`)
};

const pt_svc_automation_tlm_1 = /** @type {(inputs: Svc_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`superfície_de_gatilho`)
};

const zh_svc_automation_tlm_1 = /** @type {(inputs: Svc_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`触发器表面`)
};

const tr_svc_automation_tlm_1 = /** @type {(inputs: Svc_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tetikleyici_yüzey`)
};

const ru_svc_automation_tlm_1 = /** @type {(inputs: Svc_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`триггер_поверхность`)
};

const pl_svc_automation_tlm_1 = /** @type {(inputs: Svc_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`powierzchnia_wyzwalacza`)
};

/**
* | output |
* | --- |
* | "trigger_surface" |
*
* @param {Svc_Automation_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_automation_tlm_1 = /** @type {((inputs?: Svc_Automation_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_tlm_1(inputs)
	if (locale === "bn") return bn_svc_automation_tlm_1(inputs)
	if (locale === "de") return de_svc_automation_tlm_1(inputs)
	if (locale === "es") return es_svc_automation_tlm_1(inputs)
	if (locale === "fr") return fr_svc_automation_tlm_1(inputs)
	if (locale === "pt") return pt_svc_automation_tlm_1(inputs)
	if (locale === "zh") return zh_svc_automation_tlm_1(inputs)
	if (locale === "tr") return tr_svc_automation_tlm_1(inputs)
	if (locale === "ru") return ru_svc_automation_tlm_1(inputs)
	if (locale === "pl") return pl_svc_automation_tlm_1(inputs)
	return en_svc_automation_tlm_1(inputs)
});